import {setAccordion} from './accordion.js';
import {setCollapse} from './collapse.js';

setAccordion();
setCollapse();